import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHandleFreeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3 18c4 0 6-10 9-10s5 10 9 10" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 8,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m8 4 4 4m0 0 5 6",
			opacity: .4
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 4,
			r: 1.5,
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17,
			cy: 14,
			r: 1.5,
			strokeWidth: 1.5
		})
	]
});
export default SvgHandleFreeIcon;
